import { render } from "./SatyaDeep.vue?vue&type=template&id=1cbfe854"
import script from "./SatyaDeep.vue?vue&type=script&lang=js"
export * from "./SatyaDeep.vue?vue&type=script&lang=js"

import "./SatyaDeep.vue?vue&type=style&index=0&id=1cbfe854&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__